import React from 'react'

import { daysOfWeek } from '@/src/pages/optimus/service'

interface EditSelfReminderFormRepPatternWeeklyProps {
    isChecked: boolean
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    activeWeekDay: string
    setActiveWeekDay: React.Dispatch<React.SetStateAction<string>>
}

const weekdays = [
    { name: daysOfWeek[0], thName: 'อา' },
    { name: daysOfWeek[1], thName: 'จ' },
    { name: daysOfWeek[2], thName: 'อ' },
    { name: daysOfWeek[3], thName: 'พ' },
    { name: daysOfWeek[4], thName: 'พฤ' },
    { name: daysOfWeek[5], thName: 'ศ' },
    { name: daysOfWeek[6], thName: 'ส' },
]

const EditSelfReminderFormRepPatternWeekly: React.FC<EditSelfReminderFormRepPatternWeeklyProps> = ({
    isChecked,
    onChange,
    activeWeekDay,
    setActiveWeekDay,
}: EditSelfReminderFormRepPatternWeeklyProps) => (
    <label
        htmlFor="freq-weekly"
        className="flex flex-col p-3 border-2 rounded-b-xl h-14 select-none radio-label-weekly"
    >
        <div className="flex flex-row items-center">
            <input
                type="radio"
                id="freq-weekly"
                name="frequency"
                className="mr-2 label"
                checked={isChecked}
                onChange={onChange}
            />
            <span className="box-border block w-full text-lg font-light">เตือนสัปดาห์ละครั้ง</span>
        </div>
        <div className="flex flex-col items-center weekly-wrapper">
            <div>
                <div className="text-lg font-light py-4 text-sm font-light">
                    เลือกวันที่ต้องการเตือน
                </div>
                <div className="flex flex-row items-center justify-center">
                    {weekdays.map(({ name, thName }, idx) => (
                        <label
                            htmlFor={`weekly-input-${name}`}
                            key={idx}
                            className={`flex items-center justify-center block h-11 w-11 border-2 text-center text-lg font-light ${idx === 0 ? 'border-r' : 'border-x'} ${idx === 0 ? 'rounded-l-xl' : idx === weekdays.length - 1 ? 'rounded-r-xl' : ''} weekly-input-checked`}
                        >
                            <input
                                type="radio"
                                name="weekly-frequency"
                                id={`weekly-input-${name}`}
                                className="hidden weekly-input"
                                onChange={() => setActiveWeekDay(name)}
                                checked={activeWeekDay == name}
                            />
                            <span>{thName}</span>
                        </label>
                    ))}
                </div>
            </div>
        </div>
    </label>
)

export default EditSelfReminderFormRepPatternWeekly
export type { EditSelfReminderFormRepPatternWeeklyProps }
